export default function DashboardFiltersAndExportDirective() {
  return {
    restrict: 'E',
    template: require('./header.html'),
    bindToController: {
      equipmentId: '<',
      refreshing: '<',
      onClearAlert: '&',
    },
    controllerAs: 'vm',
    controller: AlertsBoardController,
  };
}

function AlertsBoardController(
  AlertsService,
  usersService,
  gettextCatalog,
  gettext,
  EquipmentService,
  $filter,
  $state,
) {
  'ngInject';

  const vm = this;
  const addToDataLayer = (data) => window.dataLayer.push(data);

  //Button arrays
  vm.priorityOptions = [
    {
      name: gettextCatalog.getString('All Priorities'),
      queryName: 'All Priorities',
      state: false,
      icon: '',
    },
    {
      name: gettextCatalog.getString('Low'),
      queryName: 'Low',
      state: false,
      icon: 'fa fa-exclamation-circle color-low-priority',
    },
    {
      name: gettextCatalog.getString('Medium'),
      queryName: 'Medium',
      state: false,
      icon: 'fa fa-exclamation-circle color-medium-priority',
    },
    {
      name: gettextCatalog.getString('High'),
      queryName: 'High',
      state: false,
      icon: 'fa fa-exclamation-circle color-high-priority',
    },
  ];
  vm.statusOptions = [
    {
      name: gettextCatalog.getString('All Statuses'),
      queryName: 'All Statuses',
      state: false,
    },
    {
      name: gettextCatalog.getString('Returned'),
      queryName: 'Returned',
      state: false,
    },
    {
      name: gettextCatalog.getString('Acknowledged'),
      queryName: 'Acknowledged',
      state: false,
    },
    {
      name: gettextCatalog.getString('Active'),
      queryName: 'Active',
      state: false,
    },
  ];
  vm.alertOptions = [
    {
      name: gettextCatalog.getString('All Types'),
      queryName: 'All Types',
      state: false,
    },
    {
      name: gettextCatalog.getString('Alerts'),
      queryName: 'Alerts',
      state: false,
    },
    {
      name: gettextCatalog.getString('Faults'),
      queryName: 'Faults',
      state: false,
    },
    {
      name: gettextCatalog.getString('Geozones'),
      queryName: 'Geozones',
      state: false,
    },
  ];
  vm.originalSearchText = '';

  //Public function declarations
  vm.setAlertsBtnGroup = setAlertsBtnGroup;
  vm.setPrioritiesBtnGroup = setPrioritiesBtnGroup;
  vm.setStatusBtnGroup = setStatusBtnGroup;
  vm.updateAlert = updateAlert;
  vm.getCsvFileName = getCsvFileName;
  vm.getCsvData = getCsvData;
  vm.changeFirstLoad = changeFirstLoad;
  vm.applyFilter = applyFilter;
  vm.updatePredicate = updatePredicate;

  //Public variables
  vm.search = {
    text: '',
  };
  vm.predicate = 'timestamp';
  vm.dataExist = false;
  vm.loading = false;

  //Private variables
  let alertFilter = 'any';
  let priorityFilter = 'any';
  let statusFilter = 'any';
  let orderBy = $filter('orderBy');
  let firstLoad = true;
  let currentUser = usersService.currentUser();

  vm.$onInit = () => {
    refresh();
  };
  vm.$onChanges = (changes) => {
    if (changes.refreshing.currentValue === true) {
      refresh();
    }
  };
  //Public functions
  function applyFilter() {
    vm.filteredAlerts = $filter('filter')(vm.alerts, vm.search.text);
  }

  vm.triggerAlertsKeywordFiltering = () => {
    if (vm.search.text !== '' && vm.originalSearchText !== vm.search.text) {
      addToDataLayer({
        event: 'alertsKeywordFiltering',
        data: {
          keyword: vm.search.text,
          total: vm.filteredAlerts.length,
          page: $state.current.name,
        },
      });
    }

    vm.originalSearchText = vm.search.text;
  };

  function changeFirstLoad() {
    firstLoad = false;
  }

  function setBtnGroup(option, optionsArray, optionsFilter) {
    const alertArray = [];
    const allAlertsBtn = optionsArray[0];
    if (option === allAlertsBtn.name) {
      optionsArray[0].state = !allAlertsBtn.state; // toggle all btn
      for (var alert in optionsArray) optionsArray[alert].state = allAlertsBtn.state; // toggle group
    } else {
      if (allAlertsBtn.state) optionsArray[0].state = false; // if non-all btn clicked all == false
      for (var alert in optionsArray) {
        if (optionsArray[alert].queryName === option)
          optionsArray[alert].state = !optionsArray[alert].state; // toggle clicked button
        if (optionsArray[alert].state === true) alertArray.push(optionsArray[alert].queryName); // build list of active btns
      }
      optionsArray[0].state =
        alertArray.length === optionsArray.length - 1 && !allAlertsBtn.state ? true : false;
    }

    return (optionsFilter = alertArray.length === 0 ? 'any' : alertArray.join(',').toLowerCase()); // passed to service
  }

  function setAlertsBtnGroup(option) {
    alertFilter = setBtnGroup(option, vm.alertOptions, alertFilter);

    refresh().then(() => {
      const options = vm.alertOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      addToDataLayer({
        event: 'alertsFiltering',
        data: {
          filterBy: 'type',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: vm.filteredAlerts.length,
          page: $state.current.name,
        },
      });
    });
  }

  function setPrioritiesBtnGroup(option) {
    priorityFilter = setBtnGroup(option, vm.priorityOptions, priorityFilter);

    refresh().then(() => {
      const options = vm.priorityOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      addToDataLayer({
        event: 'alertsFiltering',
        data: {
          filterBy: 'priority',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: vm.filteredAlerts.length,
          page: $state.current.name,
        },
      });
    });
  }

  function setStatusBtnGroup(option) {
    statusFilter = setBtnGroup(option, vm.statusOptions, statusFilter);

    refresh().then(() => {
      const options = vm.statusOptions
        .filter((item) => item.state === true)
        .map((item) => item.name);

      addToDataLayer({
        event: 'alertsFiltering',
        data: {
          filterBy: 'status',
          clickedOption: option,
          options,
          selected: options.includes(option),
          total: vm.filteredAlerts.length,
          page: $state.current.name,
        },
      });
    });
  }

  function updateAlert(state, singleAlert) {
    let action = null;
    singleAlert.isDisabled = true;

    if (state === 'Acknowledge') {
      action = 'acknowledged';
      AlertsService.updateAlertAcknowledge(singleAlert.instanceId).then(
        function (response) {
          singleAlert.updatedBy = currentUser.email;
          singleAlert.status = 'Acknowledged';
          singleAlert.btnState = {
            value: 'Clear',
            des: gettextCatalog.getString('Clear'),
          };
          singleAlert.isDisabled = false;
        },
        function (error) {
          let errorMsg = gettextCatalog.getString('An error occurred while retrieving data. ');
          singleAlert.isDisabled = false;
          vm.updateErrorFlag = true;
          vm.updateErrorText = errorMsg;
        },
      );
    } else if (state === 'Clear') {
      action = 'cleared';
      //Clear Alert
      AlertsService.updateAlertClear(singleAlert.instanceId).then(
        function (response) {
          singleAlert.updatedBy = currentUser.email;
          singleAlert.state = 'Closed';
          let elementPos = vm.alerts
            .map(function (x) {
              return x.instanceId;
            })
            .indexOf(singleAlert.instanceId);
          if (elementPos != -1) {
            vm.alerts.splice(elementPos, 1);
            applyFilter();
          }
          singleAlert.isDisabled = false;
          singleAlert.btnState.value === 'Cleared';
          vm.onClearAlert();
        },
        function (error) {
          let errorMsg = gettextCatalog.getString('An error occurred while retrieving data. ');
          singleAlert.isDisabled = false;
          vm.updateErrorFlag = true;
          vm.updateErrorText = errorMsg;
        },
      );
    }

    if (action !== null) {
      vm.addAlertsInteraction(singleAlert, action);
    }
  }

  //CSV file
  function getCsvFileName() {
    let fileName = gettextCatalog.getString('data_export');
    let name = gettextCatalog.getString('Active_Alerts');
    let d = new Date();
    let date =
      d.getFullYear() +
      '_' +
      (d.getMonth() + 1) +
      '_' +
      d.getDate() +
      '_' +
      d.getHours() +
      '-' +
      d.getMinutes();
    fileName += '.' + name + date;
    return fileName + '.csv';
  }

  function getCsvData() {
    let CsvData = [];

    let headers = {
      Priority: gettextCatalog.getString('Priority'),
      Type: gettextCatalog.getString('Type'),
      Time_Active: gettextCatalog.getString('Time Active'),
      Asset: gettextCatalog.getString('Asset'),
      AlertName: gettextCatalog.getString('AlertName'),
      AlertEvent: gettextCatalog.getString('AlertEvent'),
      Description: gettextCatalog.getString('Description'),
      Status: gettextCatalog.getString('Status'),
    };

    CsvData.push(headers);

    for (let i = 0; i < vm.filteredAlerts.length; i++) {
      let priority = gettextCatalog.getString(vm.filteredAlerts[i].priority);
      let activeTimeOfAlert = $filter('TableDateFilter')(vm.filteredAlerts[i].timestamp);
      let equipment = vm.filteredAlerts[i].equipment.name;
      let alertName = vm.filteredAlerts[i].name;
      let alertEvent = gettextCatalog.getString(vm.filteredAlerts[i].series.title);
      let alertEventDescription = vm.filteredAlerts[i].series.faultDescription;
      let alertType = gettextCatalog.getString(vm.filteredAlerts[i].alertType);
      //var alertEvent = vm.filteredAlerts[i].series.tags[0];
      let status = gettextCatalog.getString(vm.filteredAlerts[i].status);

      let csvObject = {
        Priority: priority,
        type: alertType,
        Time_Active: activeTimeOfAlert,
        Asset: equipment,
        AlertName: alertName,
        AlertEvent: alertEvent,
        Description: alertEventDescription,
        Status: status,
      };

      CsvData.push(csvObject);
    }
    return CsvData;
  }

  function updatePredicate(predicate) {
    vm.predicate = predicate;
  }

  //Private functions

  //displayAlertsByPage() is used to set the legnth of paging needed for AlertsDashboard.
  function displayAlertsByPage() {
    vm.totalItems = vm.filteredAlerts.length;
    let begin = (vm.current.alertPage - 1) * vm.itemsPerPage;
    let end = begin + vm.itemsPerPage;
    vm.alertsByPage = vm.filteredAlerts.slice(begin, end);
  }

  function refresh() {
    vm.loading = true;

    if (vm.equipmentId) {
      if (vm.equipmentId.length === 0) {
        vm.equipmentId = null;
      }
    }

    return new Promise((res, rej) => {
      AlertsService.getAllAlerts(vm.equipmentId, priorityFilter, statusFilter).then(
        (response) => {
          vm.dataExist = response.data.length > 0 && response.data[0] !== null ? true : false;
          vm.alerts = [];

          let currentUser = usersService.currentUser();
          let visibleDatapoints = {};
          currentUser.visibleDatapoints.forEach((dp) => {
            visibleDatapoints[dp.id] = dp;
          });

          let priorityIcons = {
            low: vm.priorityOptions[1].icon,
            medium: vm.priorityOptions[2].icon,
            high: vm.priorityOptions[3].icon,
          };

          let filters = {};
          alertFilter.split(',').forEach((filter) => {
            filters[filter] = filter;
          });

          for (let i = 0; i <= response.data.length - 1; ++i) {
            let tag = response.data[i].series.tags[0];

            if (visibleDatapoints[tag]) {
              response.data[i].notes = [];
              let obj = response.data[i];
              obj.Icon = priorityIcons[obj.priority.toLowerCase()];
              obj.Index = i;
              obj.isDisabled = false;

              switch (tag) {
                case 'dtc':
                  obj.alertType = gettext('Fault');
                  obj.alertTypeTranslation = gettextCatalog.getString('Fault');
                  break;
                case 'gps':
                  obj.alertType = gettext('Geozone');
                  obj.alertTypeTranslation = gettextCatalog.getString('Geozone');
                  break;
                default:
                  obj.alertType = gettext('Alert');
                  obj.alertTypeTranslation = gettextCatalog.getString('Alert');
                  break;
              }

              // Add translations so that filter works on different language
              obj.priorityTranslation = gettextCatalog.getString(obj.priority);
              obj.series.titleTranslation = gettextCatalog.getString(obj.series.title);
              obj.series.faultDescriptionTranslation = gettextCatalog.getString(
                obj.series.faultDescription,
              );
              obj.statusTranslation = gettextCatalog.getString(obj.status);

              // look for resource, if resource then btnState = Clear else btnState = Acknowledge
              if (response.data[i].status.toLowerCase() === 'acknowledged') {
                obj['btnState'] = {
                  value: 'Clear',
                  des: gettextCatalog.getString('Clear'),
                };
              } else {
                obj['btnState'] = {
                  value: 'Acknowledge',
                  des: gettextCatalog.getString('Acknowledge'),
                };
              }
              if (tag === 'dtc') {
                let dtcName = EquipmentService.getDtcFaultDescriptor(response.data[i].series);
                obj.series.title =
                  EquipmentService.formatFaultCode(response.data[i].series) || obj.series.title;
                if (dtcName) {
                  obj.series.faultDescription = dtcName.title;
                }
              }

              if (filters.any) {
                vm.alerts.push(obj);
              } else if (
                filters.alerts &&
                !response.data[i].series.tags[0].includes('dtc') &&
                response.data[i].series.tags[0] !== 'gps'
              ) {
                vm.alerts.push(obj);
              } else if (filters.faults && response.data[i].series.tags[0].includes('dtc')) {
                vm.alerts.push(obj);
              } else if (filters.geozones && response.data[i].series.tags[0] === 'gps') {
                vm.alerts.push(obj);
              }
            }
          }

          vm.filteredAlerts = vm.alerts.slice();

          if (vm.search.text !== '') {
            applyFilter();
          }

          vm.loading = false;

          res();
        },
        () => {
          vm.loading = false;
          vm.errorFlag = true;
          vm.errorText = gettextCatalog.getString('An error occurred while retrieving data. ');

          rej();
        },
      );
    });
  }

  gettext('Acknowledged');
  gettext('Cleared');
  gettext('Closed'); // used in equipment alert tab
  gettext('Active');

  // Add alerts table interactions to data layer
  vm.addAlertsInteraction = (alert, action) => {
    addToDataLayer({
      event: 'alertsInteraction',
      data: {
        action,
        type: alert.alertType,
        priority: alert.priority,
      },
    });
  };
}
